export default __webpack_public_path__ + "static/media/enable_cam.c375d020.svg";